import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../../shared/assets/images';

const sections = [
  {
    eyebrow: 'Normativa',
    title: 'Todo lo necesario para celebrar sin sorpresas',
    description: 'Consulta de un vistazo las condiciones y normas del cumpleaños para preparar la visita con tiempo y evitar dudas el día del evento.',
    image: images.birthdayRules,
    alt: 'Normativa de cumpleaños',
    accent: 'from-orange-100 via-white to-amber-50',
  },
  {
    eyebrow: 'Organización',
    title: 'Una jornada pensada para que el grupo disfrute',
    description: 'Aquí tienes la información práctica del cumpleaños, la dinámica general y los puntos que conviene revisar antes de reservar o venir al parque.',
    image: images.birthdayInfo,
    alt: 'Información de cumpleaños',
    accent: 'from-sky-100 via-white to-cyan-50',
  },
  {
    eyebrow: 'Tarifas',
    title: 'Precios claros para elegir la opción adecuada',
    description: 'Revisa el precio del cumpleaños y decide con calma la fórmula que mejor encaja con el grupo antes de ponerte en contacto con el equipo.',
    image: images.birthdayPriceMain,
    alt: 'Precio de cumpleaños',
    accent: 'from-rose-100 via-white to-orange-50',
  },
];

const reveal = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
};

export default function BirthdaysPage() {
  return (
    <div className="relative overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(251,191,36,0.18),_transparent_28%),linear-gradient(180deg,#fffdf7_0%,#ffffff_48%,#fff7ed_100%)]">
      <div className="absolute inset-x-0 top-0 h-48 bg-[radial-gradient(circle_at_center,_rgba(249,115,22,0.14),_transparent_58%)]" />

      <section className="relative px-4 pb-12 pt-28 md:px-6 md:pb-16 md:pt-32">
        <div className="mx-auto max-w-6xl">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mx-auto max-w-4xl text-center"
          >
            <p className="text-sm font-semibold uppercase tracking-[0.38em] text-orange-500">Cumpleaños</p>
            <h1 className="mt-5 text-5xl font-black tracking-[-0.06em] text-slate-950 md:text-7xl">
              Celebra con toda la información a la vista
            </h1>
            <p className="mx-auto mt-6 max-w-3xl text-xl leading-9 text-slate-500">
              Reúne normativa, organización y precios en una secuencia visual clara para decidir rápido y compartir los detalles con quien lo necesite.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="relative px-4 pb-20 md:px-6">
        <div className="mx-auto max-w-6xl space-y-14">
          {sections.map((section, index) => {
            const reverse = index % 2 === 1;

            return (
              <motion.article
                key={section.title}
                variants={reveal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                className={`grid items-center gap-8 overflow-hidden rounded-[36px] border border-white/70 bg-gradient-to-br ${section.accent} p-4 shadow-[0_28px_80px_rgba(15,23,42,0.08)] md:grid-cols-2 md:p-6`}
              >
                <div className={`${reverse ? 'md:order-2' : ''} overflow-hidden rounded-[28px] bg-white/60 shadow-[0_18px_50px_rgba(15,23,42,0.08)]`}>
                  <img
                    src={section.image}
                    alt={section.alt}
                    className="h-full w-full object-cover transition duration-500 hover:scale-[1.015]"
                  />
                </div>

                <div className={`${reverse ? 'md:order-1' : ''} px-3 py-4 md:px-6`}>
                  <p className="text-sm font-semibold uppercase tracking-[0.32em] text-orange-500">{section.eyebrow}</p>
                  <h2 className="mt-4 max-w-xl text-4xl font-black tracking-[-0.05em] text-slate-950 md:text-5xl">
                    {section.title}
                  </h2>
                  <p className="mt-5 max-w-xl text-lg leading-8 text-slate-600">
                    {section.description}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </section>
    </div>
  );
}
